// removed by extract-text-webpack-plugin
module.exports = {"btn":"Button-module-btn-1lqJX","pdf":"Button-module-pdf-54jN6","print":"Button-module-print-JogVD","isAutoWidth":"Button-module-isAutoWidth-3Ls5r","green":"Button-module-green-3jKkO","gray":"Button-module-gray-2RpKh","bismark":"Button-module-bismark-grHBk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.scss
// module id = 1124
// module chunks = 0